var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/sanacorp/node_modules/core-js/internals/native-promise-constructor.js
// module id = 255
// module chunks = 0